import template from "./template_crud";
export const loadGrand = template.post('/estimate/load');